import { provide, inject } from "vue";
const VaSidebarKey = Symbol("VaSidebar");
const useSidebar = (props) => {
  provide(VaSidebarKey, props);
};
const useSidebarItem = () => {
  return inject(VaSidebarKey, {
    color: "background-element"
    // activeColor: 'primary',
  });
};
export {
  useSidebarItem as a,
  useSidebar as u
};
//# sourceMappingURL=useSidebar.js.map
